<template>
  <div class="driver-message">
    <modal
      ref="modalSendMessage"
    >
    <template v-slot:body>
      <div>
        <base-textarea placeholder="Message" v-model="message"/>
      </div>
      <div class="driver-message__container-btn">
        <base-button :disabled="validationSendBtn" @click="sendMessage" >SEND MESSAGE</base-button>
      </div>
    </template>
    </modal>
    <base-button full-width @click="$refs.modalSendMessage.openModal()">SEND DRIVER IN-APP MESSAGE</base-button>
  </div>
</template>

<script>
import Modal from '@partials/Modal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import BaseTextarea from '@/components/common/BaseTextarea.vue'
import toast from '@utils/toast.js'

export default {
  name: "DriverMessage",
  components: { Modal, BaseButton, BaseTextarea,  },
  props: {
    driverId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      message: '',
    };
  },
  computed: {
    validationSendBtn() {
      return this.message.length < 1
    }
  },
  methods: {
    async sendMessage() {
      const url = '/send/app/message'
      const body = {
        data: {
          driver_id: this.driverId,
  		    message: this.message
        }
      }
      try {
        const response = await this.request(url, 'POST', body)
        if (response.code === 0) {
          this.$refs.modalSendMessage.closeModal()
          toast.successMessage('message has been sent')
          this.$emit('sendMessage')
        } else {
          toast.errorMessage(response.message)
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style>
  .driver-message__container-btn {
    text-align: center;
    margin-top: 25px;
  }
</style>